import { put, del, post, get } from "../../http";
import { root } from "../../config.json";

export const getAppointments = (id) => {
    return get(`${root}/api/v1/hospital/HAppointments/${id}`);
  };